<template>
  <v-card-text class="px-4">
    <div class="title-form mt-2 custom-font-semi-bold">Visto</div>
    <v-divider class="mt-2 mb-3"></v-divider>
    <div>
      <v-layout row wrap v-for="(havingRegardToItem, index) in entryDetail.infringements" :key="'havingRegardToItem'+index" class="mb-3">
        <v-flex xs1><div class="text-xs-center">-</div></v-flex>
        <v-flex xs11>
          <div class="text-formatted">{{ havingRegardToItem }}</div>
        </v-flex>
      </v-layout>
    </div>
    <div class="title-form mt-4 custom-font-semi-bold">Considerando</div>
    <v-divider class="mt-2 mb-3"></v-divider>
    <div>
      <v-layout row wrap v-for="(whereasItem, index) in entryDetail.acts" :key="'whereasItem'+index" class="mb-3">
        <v-flex xs1><div class="text-xs-center">-</div></v-flex>
        <v-flex xs11>
          <div class="text-formatted">{{ whereasItem }}</div>
        </v-flex>
      </v-layout>
    </div>
    <div class="title-form mt-4 custom-font-semi-bold">Resuelve</div>
    <v-divider class="mt-2 mb-3"></v-divider>
    <div>
      <v-layout row wrap v-for="(resolution, index) in entryDetail.resolves" :key="'resolution'+index" class="mb-3">
        <v-flex xs1><div class="text-xs-center">{{ index + 1 }}</div></v-flex>
        <v-flex xs11>
          <div class="text-formatted">{{ resolution }}</div>
        </v-flex>
      </v-layout>
    </div>
    <template v-if="hasTerm">
      <div class="title-form mt-4 custom-font-semi-bold">Plazo</div>
      <v-divider class="mt-2 mb-3"></v-divider>
      <div>
        <v-layout row wrap class="mx-4 px-2">
          <v-flex xs6 pr-2>
            <v-text-field v-model="date" label="Fecha" single-line prepend-icon="event" readonly></v-text-field>
          </v-flex>
          <v-flex xs6 pl-2>
            <v-text-field v-model="time" label="Hora" single-line prepend-icon="access_time" readonly></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </template>
    <template v-if="$store.getters.isSafRole || entryDetail.canViewAttachments">
      <div class="title-form mt-4 custom-font-semi-bold">Archivos adjuntos asociados</div>
      <v-divider class="mt-2 mb-3"></v-divider>
      <div class="mx-2">
        <v-data-table :items="entryDetail.assets" hide-actions hide-headers no-data-text="No hay datos disponibles">
          <template slot="items" slot-scope="props">
            <td><a :href="props.item.url" target="_blank">{{ props.item.name }}</a></td>
            <td class="text-xs-left">{{ props.item.description }}</td>
          </template>
        </v-data-table>
      </div>
    </template>
  </v-card-text>
</template>

<script>
const TIME_INDEX = 1
const DATE_INDEX = 0

export default {
  props: {
    entry: Object
  },

  computed: {
    hasTerm () {
      return this.entry.hasOwnProperty('term')
    },
    time () {
      return this.getDateTime(TIME_INDEX)
    },
    date () {
      return this.getDateTime(DATE_INDEX)
    },
    entryDetail () {
      return this.entry.detail || {}
    }
  },

  methods: {
    getDateTime (index) {
      return (this.hasTerm) ? this.entry.term.split(' ')[index] : ''
    }
  }
}
</script>

<style scoped>
.title-form {
  font-size: 1.3em;
}
</style>
